import React, { useState } from 'react';
import FilePreviewAndDownload from "../../filePreviewAndDownload";
import { PenLine, X } from 'lucide-react';

const FilePreviewHandler = ({ file, files, formatFileSize, clickableName, onClickOnName, language, groupModel, accessId, editable, onRename }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editingValue, setEditingValue] = useState('');

    const startEditing = (e) => {
        e.stopPropagation();
        const dotIndex = file.filename.lastIndexOf('.');
        const baseName = dotIndex !== -1 ? file.filename.slice(0, dotIndex) : file.filename;
        setEditingValue(baseName);
        setIsEditing(true);
    };

    const commitEdit = () => {
        const dotIndex = file.filename.lastIndexOf('.');
        const ext = dotIndex !== -1 ? file.filename.slice(dotIndex) : '';
        const newName = (editingValue.trim() || file.filename.slice(0, dotIndex || undefined)) + ext;

        if (newName !== file.filename && onRename) {
            onRename(file.id, newName);
        }
        setIsEditing(false);
    };

    const cancelEdit = () => {
        setIsEditing(false);
    };

    return (
        <div className="messageFile">
            {isEditing ? (
                <div className="conversation-file-fileName-edit-row" onClick={e => e.stopPropagation()}>
                    <div className="conversation-file-fileName-input-sizer" data-value={editingValue}>
                        <input
                            className="conversation-file-fileName-input"
                            size={1}
                            autoFocus
                            value={editingValue}
                            onChange={e => setEditingValue(e.target.value)}
                            onBlur={commitEdit}
                            onKeyDown={e => {
                                if (e.key === 'Enter') commitEdit();
                                if (e.key === 'Escape') cancelEdit();
                            }}
                        />
                    </div>
                    {file.filename.lastIndexOf('.') !== -1 && (
                        <span className="conversation-file-fileName-ext">
                            {file.filename.slice(file.filename.lastIndexOf('.'))}
                        </span>
                    )}
                    <button
                        type="button"
                        className="conversation-file-fileName-edit-btn"
                        onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            cancelEdit();
                        }}
                    >
                        <X size={12} color="#dd3c1b" />
                    </button>
                </div>
            ) : (
                <span
                    className="fileName"
                    style={{cursor: clickableName ? 'pointer' : 'default', display: 'flex', alignItems: 'center'}}
                    onClick={onClickOnName}
                    title={file.filename}
                >
                    <span className="file-fileName-text">
                        {file.filename}
                    </span>
                    {editable && (
                        <button
                            type="button"
                            className="conversation-file-fileName-edit-btn"
                            onClick={startEditing}
                            style={{background: 'none', border: 'none', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle' }}
                        >
                            <PenLine size={12} color="#3498db" />
                        </button>
                    )}
                </span>
            )}
            <FilePreviewAndDownload
                style={{ flexShrink: 0, cursor: 'pointer' }}
                key={file.id}
                file={file}
                files={files}
                language = {language}
                groupModel={groupModel}
                accessId={accessId}
            />
            {/*<span className="fileSize">{formatFileSize(file.size)}</span>*/}
        </div>
    );
};

export default FilePreviewHandler;